import { graphql } from '@/gql';
import type { UpdatePlanMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updatePlan = async (variables: UpdatePlanMutationVariables) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdatePlan($id: String!, $input: PlanUpdateInput!) {
        updatePlan(id: $id, input: $input) {
          id
          name
          kind
          amount
          isActive
          hasTrial
          trialPrice
          tier
          isDefault
          fragmentInto
          defragmentInto
          upgradeInto
          data
        }
      }
    `),
    variables,
  });

  if (!response.data?.updatePlan) {
    throw new Error('Failed to update plan');
  }

  return response.data.updatePlan;
};
